import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import client from '../../api/client';

export const fetchEscalations = createAsyncThunk('escalations/fetch', async (oem) => {
  const { data } = await client.get(`/tickets/escalations/?oem=${encodeURIComponent(oem)}`);
  return data;
});

const escalationsSlice = createSlice({
  name: 'escalations',
  initialState: { byOem: {}, loading: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEscalations.pending, (state) => { state.loading = true; })
      .addCase(fetchEscalations.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.length > 0) {
          state.byOem[action.payload[0].oem] = action.payload;
        }
      });
  },
});

export default escalationsSlice.reducer;
